const isUnauthorized = (error) => [401, 403].includes(error?.response?.status)

// An operation's 403 may be a product permission failure, not an expired
// session. Only me() can confirm invalid authentication. Never replay the
// failed operation or discard a token that replaced the request's session.
export const createSessionRevalidator = ({getToken, verifyToken, invalidate}) => {
  const pendingByToken = new Map()

  return (error, requestToken) => {
    if (!isUnauthorized(error) || !requestToken || requestToken !== getToken()) {
      return Promise.resolve(false)
    }
    if (pendingByToken.has(requestToken)) return pendingByToken.get(requestToken)

    const request = Promise.resolve().then(async () => {
      if (requestToken !== getToken()) return false
      try {
        await verifyToken(requestToken)
        return false
      } catch (verificationError) {
        if (isUnauthorized(verificationError) && requestToken === getToken()) {
          invalidate()
          return true
        }
        return false
      }
    }).finally(() => {
      pendingByToken.delete(requestToken)
    })

    pendingByToken.set(requestToken, request)
    return request
  }
}
